import React from 'react';

import Filters from './Filters';
import List from './List';

const Producer = () => {
  return (
    <>
      <Filters />
      <List />
    </>
  );
};

export default Producer;
